import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, vShow as _vShow, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c7c2a4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "card mb-4 mb-md-0" }
const _hoisted_4 = { class: "card-header border-0 pt-6" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 me-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Search Panel ")
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-site-table-toolbar": "base"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Add Design Material ")
const _hoisted_12 = { class: "card-header border-0 pt-6 d-none" }
const _hoisted_13 = { class: "card-toolbar w-100" }
const _hoisted_14 = {
  class: "d-flex w-100 justify-content-between align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_15 = { class: "me-auto" }
const _hoisted_16 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "ms-3"
}, " All ", -1))
const _hoisted_18 = { class: "fw-bolder mx-5" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Selected ")
const _hoisted_21 = { class: "card-header border-0 pt-6" }
const _hoisted_22 = { class: "card-title" }
const _hoisted_23 = { class: "row w-100" }
const _hoisted_24 = { class: "col-md-12 d-flex align-items-center position-relative my-1" }
const _hoisted_25 = { class: "card-toolbar" }
const _hoisted_26 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_27 = {
  key: 0,
  class: "card-body pt-0 d-none d-md-block"
}
const _hoisted_28 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sub", null, "sec", -1))
const _hoisted_32 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil p-0" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash p-0" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "d-md-none d-block" }
const _hoisted_40 = {
  key: 0,
  class: "card"
}
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "No Data Found", -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" to add new Design Material ")
const _hoisted_45 = { class: "card-header ribbon" }
const _hoisted_46 = { class: "card-title" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "ribbon-label bg-info" }
const _hoisted_49 = { class: "card-body px-0 pb-0 d-flex align-items-center mb-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-3" }, null, -1))
const _hoisted_51 = { class: "flex-grow-1" }
const _hoisted_52 = { class: "d-flex" }
const _hoisted_53 = ["href"]
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "ms-4" }
const _hoisted_56 = {
  key: 0,
  class: "text-muted fw-bold d-block"
}
const _hoisted_57 = {
  key: 1,
  class: "text-muted fw-bold d-block"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Stock : ")
const _hoisted_59 = { style: { color: '#2c2c2c' } }
const _hoisted_60 = {
  key: 2,
  class: "text-muted fw-bold d-block"
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Unit : ")
const _hoisted_62 = { style: { color: '#2c2c2c' } }
const _hoisted_63 = {
  key: 3,
  class: "text-muted fw-bold d-block"
}
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Size : ")
const _hoisted_65 = { style: { color: '#2c2c2c' } }
const _hoisted_66 = {
  key: 4,
  class: "text-muted fw-bold d-block"
}
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Timing : ")
const _hoisted_68 = { style: { color: '#2c2c2c' } }
const _hoisted_69 = {
  key: 5,
  class: "text-muted fw-bold d-block",
  style: {
                      display: 'flex',
                      alignItems: 'center',
                    }
}
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Color :  ")
const _hoisted_71 = { style: { color: '#2c2c2c' } }
const _hoisted_72 = { class: "card-footer d-flex justify-content-center pt-5" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1))
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "d-flex justify-content-center pt-5 pb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBack && _ctx.onClickBack(...args)))
      }, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "d-flex align-items-center position-relative my-1 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchPanel = !_ctx.showSearchPanel))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.hasCreate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addDesignMaterial({})))
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/navigation/Plus.svg" })
                  ]),
                  _hoisted_11
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAllDesignMaterial) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAllDesignMaterial]
                ]),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.selectAllDesignMaterial ? _ctx.total : _ctx.checkedDesignMaterial.length), 1),
              _hoisted_20
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportFewSites()))
            }, " Export CSV Selected ")
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchData.name) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Search By Name"
              }, null, 512), [
                [_vModelText, _ctx.searchData.name]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems()))
            }, " Search ")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchPanel]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              total: _ctx.total,
              rowsPerPage: 10,
              onPageChange: _ctx.onPageChange,
              currentPage: _ctx.currentPage
            }, {
              "cell-checkbox": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.selectAllDesignMaterial)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        checked: "",
                        disabled: ""
                      }, null, 8, _hoisted_29))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedDesignMaterial) = $event))
                      }, null, 8, _hoisted_30)), [
                        [_vModelCheckbox, _ctx.checkedDesignMaterial]
                      ])
                ])
              ]),
              "cell-cuttingCost": _withCtx(({ row: site }) => [
                _createTextVNode(" ₹ " + _toDisplayString(site.cuttingCost) + " / " + _toDisplayString(site.cuttingTime) + " ", 1),
                _hoisted_31
              ]),
              "cell-size": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.width) + " (W) X " + _toDisplayString(site.height) + " (H) = " + _toDisplayString(site.width * site.height) + " sq " + _toDisplayString(site.material_data.unit), 1)
              ]),
              "cell-material": _withCtx(({ row: site }) => [
                _createVNode(_component_router_link, {
                  to: {
                name: 'apps-edit-material',
                params: { id: site.material_data.id },
              }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(site.material_data.code), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-design_data": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.design_data.code), 1)
              ]),
              "cell-created_by": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.userList[site.created_by]?.name), 1)
              ]),
              "cell-actions": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_32, [
                  (_ctx.hasEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.addDesignMaterial(site))
                      }, _hoisted_35, 8, _hoisted_33))
                    : _createCommentVNode("", true),
                  (_ctx.hasDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-danger btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.deleteDesignMaterialItem(site))
                      }, _hoisted_38, 8, _hoisted_36))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "total", "onPageChange", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", null, [
        (_ctx.tableData.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                (_ctx.hasCreate)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                      _createElementVNode("span", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addDesignMaterial({}))),
                        class: "cursor-pointer text-primary"
                      }, "Click here"),
                      _hoisted_44
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card card-flush mb-4 shadow",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("h3", _hoisted_46, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.addDesignMaterial(item)),
                  style: {
                  backgroundColor: 'transparent',
                  border: 'none',
                  padding: '0px',
                }
                }, _toDisplayString(item.material_data?.code), 9, _hoisted_47)
              ]),
              _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.userList[item.created_by]?.username), 1)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      target: "blank",
                      href: 
                      item.material_data.image
                        ? item.material_data.image
                        : 'media/logos/logo.png'
                    
                    }, [
                      _createElementVNode("img", {
                        style: {
                        width: '100px',
                        height: '100px',
                        'margin-right': '12px',
                      },
                        src: 
                        item.material_data.image
                          ? item.material_data.image
                          : 'media/logos/logo.png'
                      ,
                        alt: ""
                      }, null, 8, _hoisted_54)
                    ], 8, _hoisted_53)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    (item.material_data?.code)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createVNode(_component_router_link, {
                            to: {
                        name: 'apps-edit-material',
                        params: { id: item.material_data.id },
                      }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.material_data.code), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.material_data.stock && _ctx.hasStock)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _hoisted_58,
                          _createElementVNode("strong", _hoisted_59, _toDisplayString(item.material_data.stock), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.material_data.unit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("strong", _hoisted_62, _toDisplayString(item.material_data.unit), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.height && item.width)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("strong", _hoisted_65, _toDisplayString(item.width) + " X " + _toDisplayString(item.height) + " " + _toDisplayString(item.material_data.unit
                          ? item.material_data.unit
                          : "Inch"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.cuttingCost && item.cuttingTime && _ctx.hasCost)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                          _hoisted_67,
                          _createElementVNode("strong", _hoisted_68, "₹ " + _toDisplayString(item.cuttingCost) + " | " + _toDisplayString(item.cuttingTime) + " sec", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.material_data?.color)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _hoisted_70,
                          _createElementVNode("strong", _hoisted_71, _toDisplayString(item.material_data.color), 1),
                          _createElementVNode("span", {
                            style: _normalizeStyle({
                        backgroundColor: item.material_data.color,
                        display: 'inline-block',
                        width: '1rem',
                        height: '1rem',
                        marginLeft: '8px',
                        border: '.5px solid #2c2c2c',
                      })
                          }, null, 4)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mx-2 w-100",
                onClick: ($event: any) => (_ctx.addDesignMaterial(item))
              }, _hoisted_75, 8, _hoisted_73),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger mx-2 w-100",
                onClick: ($event: any) => (_ctx.deleteDesignMaterialItem(item))
              }, _hoisted_78, 8, _hoisted_76)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_79, [
        _createVNode(_component_el_pagination, {
          "current-page": _ctx.currentPage,
          "onUpdate:current-page": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentPage) = $event)),
          onCurrentChange: _ctx.onPageChange,
          "page-size": 10,
          layout: "prev, pager, next",
          total: _ctx.total,
          "hide-on-single-page": false,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "total"])
      ])
    ])
  ]))
}